module.exports = __webpack_public_path__ + "img/decode-correct.98f710f7.png";